import * as React from 'react';

export function TimeCheckSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}>
      <path d="M23.707 16.325a1 1 0 00-1.414 0l-5.627 5.628-2.688-2.653a1 1 0 00-1.435 1.4l2.744 2.7a1.876 1.876 0 001.345.6h.033A1.873 1.873 0 0018 23.447l5.707-5.708a1 1 0 000-1.414z" />
      <path d="M11.09 21.959A10 10 0 1122 12c0 .307-.015.611-.041.911A1 1 0 0022.866 14a.989.989 0 001.085-.907c.032-.363.049-.726.049-1.093a12 12 0 10-13.09 11.951h.091a1 1 0 00.089-2z" />
      <path d="M11 7v4.586l-2.707 2.707a1 1 0 101.414 1.414l3-3A1 1 0 0013 12V7a1 1 0 00-2 0z" />
    </svg>
  );
}
